import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';

const PRIMARY_COLOR = '#1976d2';
const PRIMARY_COLOR_HOVER_BG = 'rgba(25, 118, 210, 0.04)';
const DANGER_COLOR = '#e53935';

const useStyles = makeStyles(() => ({
  cancelButton: {
    color: `${PRIMARY_COLOR} !important`,
    borderColor: `${PRIMARY_COLOR} !important`,
    borderRadius: '4px !important',
    padding: '8px 24px !important',
    textTransform: 'none !important',
    backgroundColor: '#ffffff !important',
    '&:hover': {
      backgroundColor: `${PRIMARY_COLOR_HOVER_BG} !important`,
      borderColor: `${PRIMARY_COLOR} !important`,
    },
    '&:focus': { outline: 'none !important' },
    '&::-moz-focus-inner': { border: 0 },
  },
  deleteButton: {
    backgroundColor: `${DANGER_COLOR} !important`,
    color: '#ffffff !important',
    borderRadius: '4px !important',
    padding: '8px 32px !important',
    textTransform: 'none !important',
    boxShadow: 'none !important',
    '&:hover': { backgroundColor: '#b32a26 !important' },
    '&:focus': { outline: 'none !important' },
    '&::-moz-focus-inner': { border: 0 },
    '&.Mui-disabled': {
      backgroundColor: '#e5b3b3 !important',
      color: '#ffffff !important',
    },
  },
}));

export default function ConfirmDeleteModal({
  open,
  guestName,
  loading,
  onCancel,
  onConfirm,
}) {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onCancel}
      maxWidth="xs"
      fullWidth
      PaperProps={{ style: { borderRadius: 8 } }}
    >
      <Box style={{ background: '#ffffff', padding: 24 }}>
        <Box mb={2}>
          <Typography variant="h6" style={{ fontWeight: 600 }}>
            Excluir convidado
          </Typography>
        </Box>

        <Box mb={3}>
          <Typography variant="body2" color="textSecondary">
            Tem certeza que deseja excluir{' '}
            <strong>{guestName || 'este convidado'}</strong>? O acesso à
            plataforma será revogado imediatamente.
          </Typography>
        </Box>

        <Box display="flex" justifyContent="flex-end" gridGap={12}>
          <Button
            variant="outlined"
            onClick={onCancel}
            disabled={loading}
            className={classes.cancelButton}
          >
            Cancelar
          </Button>
          <Button
            variant="contained"
            onClick={onConfirm}
            disabled={loading}
            className={classes.deleteButton}
            startIcon={
              loading ? (
                <CircularProgress size={16} style={{ color: '#fff' }} />
              ) : null
            }
          >
            {loading ? 'Excluindo...' : 'Excluir'}
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
}
